const fonts = {
    body: 'Roboto, Open Sans',
    heading: 'Roboto, Open Sans',
    mono: 'Roboto, Open Sans',
};

export default fonts;
